import { useState } from 'react';
import { Link } from 'react-router-dom';

export function CarsUnder30kFaq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: "What's the best value in the $20K-$30K range?",
      answer: "Honda CR-V, Toyota RAV4, and Mazda CX-5 (2018-2020) offer the best reliability and resale value. For sedans, Honda Accord and Toyota Camry are hard to beat. For trucks, look at Toyota Tacoma or Ford F-150 with higher mileage but solid maintenance records."
    },
    {
      question: "Should I buy at the top of my budget or save money?",
      answer: "Buy what you need, not what you can afford. A $25K vehicle that meets your needs is smarter than stretching to $30K for features you won't use. Remember to budget for insurance, fuel, and maintenance - those costs add up quickly."
    },
    {
      question: "Are luxury brands worth it at this price point?",
      answer: "It depends. A 2017 Lexus ES at $28K will be more reliable than a 2017 BMW 5-Series at the same price. Lexus, Acura, and Genesis offer luxury without the maintenance headaches. Avoid German luxury unless you have a maintenance budget."
    },
    {
      question: "What mileage should I expect for $30K?",
      answer: "For most reliable brands, 30K-60K miles is the sweet spot. You're past the steep depreciation curve but still have plenty of life left. High-mileage highway miles (80K+) on a well-maintained vehicle can be a better deal than low-mileage city miles with spotty maintenance."
    },
    {
      question: "Do you offer warranties on vehicles under $30K?",
      answer: "Many vehicles in this range still have remaining factory warranty. We also offer extended warranty options through reputable providers. Ask about warranty coverage on any vehicle you're considering - we'll be transparent about what's included."
    },
    {
      question: "Can I negotiate the price?",
      answer: "Our prices are already competitive and transparent - no dealer markup games. That said, we're reasonable people. If you find a comparable vehicle priced lower elsewhere, let's talk. We'd rather earn your business than lose it over a few hundred dollars."
    },
    {
      question: "What if I need to sell my current car?",
      answer: "We buy cars outright and offer fair trade-in values. Get a quote on our Sell Your Car page - it takes 2 minutes. We'll beat most dealer trade-in offers because we don't play the \"low trade, high sale\" game."
    },
    {
      question: "Do you deliver to SW Washington and the Oregon Coast?",
      answer: "Yes! Free delivery to Astoria, Seaside, Cannon Beach, Long Beach, Ilwaco, and surrounding areas. We'll bring the vehicle to you for a test drive and complete the paperwork at your convenience."
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Common Questions About $20K-$30K Vehicles
          </h2>
          <p className="text-lg text-gray-600">
            Real answers to questions real buyers ask
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-4">
          {faqs.map((faq, index) => {
            const btnId = `u30k-faq-btn-${index}`;
            const panelId = `u30k-faq-panel-${index}`;
            const isOpen = openIndex === index;
            return (
              <div
                key={index}
                className="bg-white rounded-xl shadow-sm overflow-hidden"
              >
                <button
                  id={btnId}
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  aria-expanded={isOpen}
                  aria-controls={panelId}
                  className="w-full px-6 py-5 text-left flex items-center justify-between hover:bg-gray-50 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[#1E3A5F]"
                >
                  <span className="font-semibold text-lg pr-4">{faq.question}</span>
                  <i
                    aria-hidden="true"
                    className={`ri-arrow-down-s-line text-2xl text-blue-600 transition-transform flex-shrink-0 ${
                      isOpen ? 'rotate-180' : ''
                    }`}
                  ></i>
                </button>
                {isOpen && (
                  <div
                    id={panelId}
                    role="region"
                    aria-labelledby={btnId}
                    className="px-6 pb-5 text-gray-600 leading-relaxed"
                  >
                    {faq.answer}
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <div className="max-w-3xl mx-auto mt-12 text-center">
          <p className="text-gray-600 mb-6">
            Still have questions? We're here to help, not sell.
          </p>
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 bg-[#1C2B1E] text-white px-8 py-4 rounded-lg font-semibold hover:bg-[#2C3E55] transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-[#1C2B1E]"
          >
            <i className="ri-chat-3-line text-xl"></i>
            Ask Us Anything
          </Link>
        </div>
      </div>
    </section>
  );
}
